// โครงสร้างข้อมูลสำหรับ Farm Dashboard

/**
 * โครงสร้างข้อมูล Farm Info (ข้อมูลเกี่ยวกับ farm)
 */
export const createFarmInfoModel = (data) => {
  return {
    farmId: data.farmId || '', // userId ของ farm
    farmName: data.farmName || '',
    description: data.description || '',
    
    // ความรู้และประสบการณ์
    knowledge: data.knowledge || '', // ความรู้
    experience: data.experience || '', // ประสบการณ์
    yearsOfExperience: data.yearsOfExperience || 0,
    
    // ข้อมูลติดต่อ
    contact: {
      phone: data.contact?.phone || '',
      email: data.contact?.email || '',
      address: data.contact?.address || '',
      website: data.contact?.website || ''
    },
    
    // รูปภาพ
    logo: data.logo || '',
    coverImage: data.coverImage || '',
    gallery: data.gallery || [],
    
    // ข้อมูลการจัดการ
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * โครงสร้างข้อมูล Greenhouse (โรงเรือน)
 */
export const createGreenhouseModel = (data) => {
  return {
    farmId: data.farmId || '',
    name: data.name || '', // ชื่อโรงเรือน
    description: data.description || '',
    
    // ขนาด
    area: data.area || 0, // พื้นที่ (ตารางเมตร)
    unit: data.unit || 'sqm',
    
    // ประเภทโรงเรือน
    type: data.type || '', // indoor, outdoor, greenhouse, hybrid
    capacity: data.capacity || 0, // ความจุ (ต้น)
    
    // สถานะ
    status: data.status || 'active', // active, inactive, maintenance
    isActive: data.isActive !== undefined ? data.isActive : true,
    
    // ข้อมูลการจัดการ
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * โครงสร้างข้อมูล Growing Method (รูปแบบการปลูก)
 */
export const createGrowingMethodModel = (data) => {
  return {
    farmId: data.farmId || '',
    name: data.name || '', // ชื่อรูปแบบการปลูก
    description: data.description || '',
    
    // ประเภท
    type: data.type || '', // soil, hydroponic, aeroponic, organic, etc.
    
    // ข้อมูลเพิ่มเติม
    details: data.details || {}, // ข้อมูลเฉพาะแต่ละวิธี
    
    // สถานะ
    isActive: data.isActive !== undefined ? data.isActive : true,
    
    // ข้อมูลการจัดการ
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * โครงสร้างข้อมูล Strain (สายพันธุ์ที่เชี่ยวชาญ)
 */
export const createStrainModel = (data) => {
  return {
    farmId: data.farmId || '',
    name: data.name || '', // ชื่อสายพันธุ์
    description: data.description || '',
    
    // ประเภท
    type: data.type || '', // Sativa, Indica, Hybrid
    thcLevel: data.thcLevel || null, // เปอร์เซ็นต์ THC
    cbdLevel: data.cbdLevel || null, // เปอร์เซ็นต์ CBD
    
    // คุณสมบัติ
    effects: data.effects || [], // [relaxing, energizing, etc.]
    flavors: data.flavors || [], // [earthy, fruity, etc.]
    
    // ประสบการณ์
    timesGrown: data.timesGrown || 0, // ปลูกกี่ครั้งแล้ว
    averageYield: data.averageYield || 0, // ผลผลิตเฉลี่ย (กรัม/ต้น)
    
    // รูปภาพ
    images: data.images || [],
    
    // สถานะ
    isActive: data.isActive !== undefined ? data.isActive : true,
    
    // ข้อมูลการจัดการ
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * โครงสร้างข้อมูล Growing Cycle (รอบการปลูก)
 */
export const createGrowingCycleModel = (data) => {
  return {
    farmId: data.farmId || '',
    greenhouseId: data.greenhouseId || null, // ID โรงเรือน (ถ้ามี)
    strainId: data.strainId || '', // ID สายพันธุ์
    strainName: data.strainName || '', // ชื่อสายพันธุ์
    
    // ข้อมูลการปลูก
    quantity: data.quantity || 0, // จำนวนต้น
    growingMethodId: data.growingMethodId || null, // ID รูปแบบการปลูก
    
    // วันที่
    startDate: data.startDate || new Date(), // วันที่เริ่มปลูก
    expectedHarvestDate: data.expectedHarvestDate || null, // วันที่คาดว่าจะเก็บเกี่ยว
    actualHarvestDate: data.actualHarvestDate || null, // วันที่เก็บเกี่ยวจริง
    
    // สถานะ
    status: data.status || 'planting', // planting, growing, flowering, harvesting, completed, cancelled
    progress: data.progress || 0, // เปอร์เซ็นต์ความคืบหน้า (0-100)
    
    // ผลผลิต
    expectedYield: data.expectedYield || 0, // ผลผลิตที่คาดหวัง (กรัม)
    actualYield: data.actualYield || null, // ผลผลิตจริง (กรัม)
    
    // หมายเหตุ
    notes: data.notes || '',
    
    // ข้อมูลการจัดการ
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};












